import { render, staticRenderFns } from "./AdManage.vue?vue&type=template&id=0c508858&"
import script from "./AdManage.vue?vue&type=script&lang=ts&"
export * from "./AdManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports